import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import * as _ from "lodash";
import * as React from "react";
import { dashboardTheme } from "../../../styles/DashboardTheme";
import { ClutchBase, TeamStat } from "../model/FixtureDetailed";
import "./FixtureScoreboardView.css";

export interface Props {
    teamName: string | undefined;
    teamStats: TeamStat | undefined;
    isLiveFixture: boolean;
}

export interface State {
}

export class FixtureScoreboardView extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);
    }

    private formatNumber(num: number) : string | number {
        return Number.isNaN(num) ? "-" : num;
    }

    render() {
        return (
            <MuiThemeProvider theme={scoreboardTheme}>
                <Table>
                    <TableHead>
                        <TableRow className="scoreboard-catagories" >
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell colSpan={4} style={{ textAlign: "center"}}>
                                &nbsp;
                            </TableCell>
                            <TableCell colSpan={6} style={{ textAlign: "center" }}>
                                Clutches
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow className="scoreboard-header striped-row">
                            <TableCell>
                                {this.props.teamName}
                            </TableCell>
                            <Tooltip placement="top" title='Kills'>
                                <TableCell>K</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='Deaths'>
                                <TableCell>D</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='Assists (flash)'>
                                <TableCell>A (f)</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='Kill-death ratio'>
                                <TableCell>K/D</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='1v2 clutches'>
                                <TableCell>1v2</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='1v3 clutches'>
                                <TableCell>1v3</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='1v4 clutches'>
                                <TableCell>1v4</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='1v5 clutches'>
                                <TableCell>1v5</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='4-kill clutches'>
                                <TableCell>4K</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='5-kill clutches'>
                                <TableCell>5K</TableCell>
                            </Tooltip>
                            <Tooltip placement="top" title='Entry kills'>
                                <TableCell>EK</TableCell>
                            </Tooltip>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {!this.props.teamStats && _.range(0, 5).map((_, i) => (
                            <TableRow key={i} {...((i % 2) ? { className: "striped-row" } : {})}>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        ))}

                        {this.props.teamStats && _(this.props.teamStats.players)
                            .sortBy(player => player.deaths).reverse()
                            .sortBy(player => player.kills).reverse()
                            .map((player, i) => (
                                <TableRow key={i} {...((i % 2) ? { className: "striped-row" } : {})}>
                                    
                                    <Tooltip title={`ID: ${player.playerId}`} placement="left">
                                        <TableCell>{player.name}</TableCell>
                                    </Tooltip>
                                    <TableCell>{this.formatNumber(player.kills)}</TableCell>
                                    <TableCell>{this.formatNumber(player.deaths)}</TableCell>
                                    <TableCell>{`${this.formatNumber(player.assists)} (${this.formatNumber(player.flash_assists)})`}</TableCell>
                                    <TableCell>{(player.kills / Math.max(1, player.deaths)).toFixed(2)}</TableCell>
  


                                    {_.range(2,5+1).map(clutchId => 
                                        player.clutches?.filter(clutch => Number(clutch.type.split("v")[1]) === clutchId).length > 0
                                        || 
                                            (player.clutches?.filter(clutch => Number(clutch.type.split("v")[1]) === clutchId) === undefined
                                            && player.oneVersusXs?.filter(clutch => clutch.id === clutchId)?.length) ?
                                        
                                            <Tooltip
                                            title={
                                                <span>
                                                {player.clutches && _.chain(player.clutches)
                                                    .filter(clutch => Number(clutch.type.split("v")[1]) === clutchId)
                                                    .groupBy(clutch => clutch.mapNumber)
                                                    .map((value, key) => `Map ${key} | Round(s) ${value.map(clutch => clutch.round).join(", ")}`)
                                                    .value().map(formattedClutches => <p>{formattedClutches}</p>)
                                                }

                                                {!player.clutches && _.chain(player.oneVersusXs!)
                                                    .filter(clutch => clutch.id === clutchId)
                                                    .groupBy(clutch => clutch.mapNumber)
                                                    .map((value, key) => `Map ${key} | Round(s) ${value.map(clutch => clutch.roundNumber).join(", ")}`)
                                                    .value().map(formattedClutches => <p>{formattedClutches}</p>)
                                                }
                                                </span>
                                            }
                                            placement="left"
                                            >
                                                <TableCell>
                                                    {player.clutches && player.clutches?.filter(clutch => Number(clutch.type.split("v")[1]) === clutchId).length}
                                                    {!player.clutches && player.oneVersusXs?.filter(clutch => clutch.id === clutchId)!.length}
                                                </TableCell>
                                            </Tooltip>
                                                :
                                                <TableCell>{this.props.isLiveFixture ? "-" : ""}</TableCell>

                                    )}
                                    {_.range(4,5+1).map(clutchId => {
                                        const matching = (player.multiKills || []).filter(mk =>
                                            // support live data shape with numeric `id` or verified JSON with `type` like "4K"/"5K"
                                            (mk as any).id === clutchId ||
                                            ((mk as any).type && Number(String((mk as any).type).replace(/\D/g, '')) === clutchId)
                                        );

                                        return matching.length ? (
                                            <Tooltip
                                                title={
                                                    <span>
                                                        {_.chain(matching)
                                                            .groupBy(mk => mk.mapNumber ?? 1)
                                                            .map((value, key) => `Map ${key} | Round(s) ${value.map(mk => (mk as any).roundNumber ?? (mk as any).round).join(', ')}`)
                                                            .value().map(formattedClutches => <p>{formattedClutches}</p>)}
                                                    </span>
                                                }
                                                placement="left"
                                            >
                                                <TableCell>
                                                    {matching.length}
                                                </TableCell>
                                            </Tooltip>
                                        ) : (
                                            <TableCell>{this.props.isLiveFixture ? "-" : ""}</TableCell>
                                        );
                                    })}
                                    {player.entryKillClutches?.length ? 
                                        <Tooltip
                                            title={ player.entryKills !== player.entryKillClutches?.length ?
                                                <span>Round info not available</span> :
                                                <span>
                                                    {_.chain(player.entryKillClutches!)
                                                        .groupBy(clutch => clutch.mapNumber)
                                                        .map((value, key) => `Map ${key} | Round(s) ${value.map(clutch => clutch.roundNumber).join(", ")}`)
                                                        .value().map(formattedClutches => <p>{formattedClutches}</p>)}
                                                </span>
                                            }
                                            placement="left"
                                            >
                                            <TableCell>{this.formatNumber(player.entryKills)}</TableCell>
                                        </Tooltip>
                                        :
                                        <TableCell>{this.formatNumber(player.entryKills)}</TableCell>
                                    }
                                </TableRow>
                            )).value()}
                    </TableBody>
                </Table>
            </MuiThemeProvider>
        )
    }
}

export const scoreboardTheme = createMuiTheme({
    ...dashboardTheme,
    palette: {
    },
    overrides: {
        MuiTable: {
            root: {}
        },
        MuiTableCell: {
            root: {
                borderBottom: "0",
                padding: "8px 0px 8px 0px",
                "&:first-child": {
                    letterSpacing: "1px",
                    color: "black",
                    paddingLeft: "25px",
                    textAlign: "left",
                    // overflow: 'hidden',
                    // display: 'block'
                },

                "&:not(:first-child)": {
                    color: "rgb(77, 77, 77)",
                    textAlign: "center",
                    width: "calc(90%/12)"
                },

                "&:last-child": {
                    paddingRight: "5px"
                },
            },
        },

        MuiTableRow: {
            root: {

                height: 0,
            },
            head: {
                height: 0,

                "&:first-child": {
                },

                "&:not(:first-child)": {

                }
            }
        }
    }
})



